import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueSweetalert2 from "vue-sweetalert2"
import axios from "axios"

import { ToastPlugin, useToast } from "vue-toast-notification"
import "vue-toast-notification/dist/theme-sugar.css"
import i18n from "./lang/config"
const ioClient = require("socket.io-client")
import bootstrap from "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import moment from "moment"
require("moment/locale/tr")
import VCalendar from "v-calendar"
import "v-calendar/style.css"

import "@/assets/packet/fontawesome-free-5.15.3-web/css/all.min.css"
import "@/assets/css/eklentiler.css"
import "@/assets/css/cards.css"
import "@/assets/css/Style.css"
import "@/assets/css/sweetalert2.min.css"

const app = createApp(App)
app.use(VueSweetalert2)
app.use(ToastPlugin)
app.use(bootstrap)
app.use(i18n)
app.use(VCalendar, {})

import tableAlerts from "@/components/tableAlerts.vue"
import btnReload from "@/components/btn_reload.vue"
import searchArea from "@/components/searchArea.vue"
import paginationArea from "@/components/pagination.vue"
import powerMonitor from "@/components/powerMonitor.vue"
import imgMonitor from "@/components/imgMonitor.vue"
import videoMonitor from "@/components/videoMonitor.vue"
import VueJsonPretty from "vue-json-pretty"
import "vue-json-pretty/lib/styles.css"
import VueSpeedometer from "vue-speedometer/slim"
app.component("TableAlerts", tableAlerts)
app.component("btnReload", btnReload)
app.component("searchArea", searchArea)
app.component("paginationArea", paginationArea)
app.component("VueJsonPretty", VueJsonPretty)
app.component("VueSpeedometer", VueSpeedometer)
app.component("powerMonitor", powerMonitor)
app.component("imgMonitor", imgMonitor)
app.component("videoMonitor", videoMonitor)

/* ========================= =========================== other =========================== ========================= */
const devStatus = false
const axiosAddr = devStatus ? "http://localhost:5020" : "/cfr"
const axiosMachineAddr = devStatus ? "http://localhost:5020" : "/cfr/socket.io"

import CryptoJS from "crypto-js"
app.config.globalProperties.$crypto = {
    encrypted(data) {
        const ciphertext = CryptoJS.AES.encrypt(data, process.env.VUE_APP_passphrase).toString()
        return ciphertext
    },
    decrypted(data) {
        const decryptedText = CryptoJS.AES.decrypt(data, process.env.VUE_APP_passphrase).toString(CryptoJS.enc.Utf8)
        return decryptedText
    },
    say_my_auth(data, main) {
        const decryptedText = CryptoJS.AES.decrypt(data, process.env.VUE_APP_passphrase).toString(CryptoJS.enc.Utf8)
        var auth = JSON.parse(decryptedText).userAuthority.filter((x) => x.main == main)[0]
        if (auth != undefined) return auth.sub
        else return []
    },
    sha256(data) {
        const decryptedText = CryptoJS.SHA256(data).toString()
        return decryptedText
    },
}

app.config.globalProperties.$timeRule = {
    zone(time) {
        let localDate = undefined
        if (time) {
            const date = new Date(time)
            localDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(
                date.getSeconds()
            ).padStart(2, "0")}`
        }
        return localDate
    },
}

import Vuesax from "vuesax3"
import "material-icons/iconfont/material-icons.css"
import "vuesax3/dist/vuesax.css"
app.use(Vuesax, {})

/* ========================= ========================= Socket.io ========================= ========================= */
app.config.globalProperties.$socket = {
    connect() {
        const socketTest = devStatus ? ioClient.connect(axiosMachineAddr, { reconnect: true }) : ioClient.connect("/", { path: axiosMachineAddr, reconnect: true })

        app.config.globalProperties.$socketDatabase = socketTest
        app.config.globalProperties.$socketPLC = socketTest

        socketTest.emit("ping", { token: localStorage.token, selected_machine: localStorage.selected_machine })

        socketTest.on('controlPLC', data => {
        try {
            store.state.controlPLC = data;
            store.state.plcDelayList.push(data.readDelay || 0);
            if (store.state.plcDelayList.length > 100) store.state.plcDelayList.shift();
        } catch (error) {
            console.log('controlPLC Error');
        }
        });

        socketTest.on('tourMonitor', data => {
        try {
            store.state.monitorData = data;
        } catch (error) {
            console.log('monitorData Error');
        }
        });

        socketTest.on('allServiceData', data => {
        try {
            store.state.services = data;
            store.state.systemDate = data[0].date;
            store.state.roboConfig.license = data[0].license;
        } catch (error) {
            console.log('allServiceData Error');
        }
        });

    },
}

/* ========================= ===================== global functions ====================== ========================= */
app.config.globalProperties.$t = i18n.global.t

app.config.globalProperties.$moment = {
    moment(value) {
        return moment(value)
    },
    now() {
        return moment()
    },
    long() {
        return moment().format(`YYYY-MM-DD HH:mm:ss`)
    },
    date() {
        return moment().format("YYYY-MM-DD")
    },
    lastDay(count) {
        return moment().startOf("day").subtract(count, "days").format("YYYY-MM-DD")
    },
    ago(value) {
        return moment(value).startOf().fromNow()
    },
    daysDiff(date) {
        return moment(date).diff(moment(), "days")
    },
    dateDiff(date1, date2) {
        return Math.floor((new Date(date1).getTime() - new Date(date2).getTime()) / 1000)
    },
    name() {
        return moment().format(`YYYYMMDDHHmmssms`)
    },
    format(date) {
        return moment(date).format(`YYYY-MM-DD HH:mm:ss`)
    },
}

app.config.globalProperties.$alertBox = {
    success(msg) {
        alertBox({ type: "success", msg: msg })
    },
    error(msg) {
        alertBox({ type: "error", msg: msg })
    },
    info(msg) {
        alertBox({ type: "info", msg: msg })
    },
    authInfo(msg) {
        if (store.state.auth.authority) alertBox({ type: "info", msg: msg })
    },
    warning(msg) {
        alertBox({ type: "warning", msg: msg })
    },
    hardWarning(msg, time) {
        hardAlert({ type: "warning", msg: msg, time })
    },
    cancel() {
        alertBox({ type: "warning", msg: app.config.globalProperties.$t("op.canceled") })
    },
    notDelete() {
        alertBox({ type: "warning", msg: app.config.globalProperties.$t("alerts.noDeleteInUsed") })
    },
    ops() {
        alertBox({ type: "warning", msg: app.config.globalProperties.$t("alerts.tryAgainaLater") })
    },
    unAuthorized() {
        alertBox({ type: "error", msg: app.config.globalProperties.$t("alerts.onlyAuth") })
    },
}

export function alertBox({ type, msg }) {
    useToast().open({
        position: store.state.toastrAlert.alertPosition,
        message: msg,
        type: type,
        duration: store.state.toastrAlert.alertduration,
        pauseOnHover: true,
    })
}

export function hardAlert({ type, msg, time }) {
    useToast().open({
        position: store.state.toastrAlert.alertPosition,
        message: msg,
        type: type,
        duration: time ? time : null,
        pauseOnHover: true,
    })
}

app.config.globalProperties.$filters = {
    formatL(value) {
        if (value != null || value != undefined) {
            value = Number(value)
            if (value < 0) {
                return 0 + " ml"
            } else if (value <= 999) {
                return value + " ml"
            } else if (value > 999 && value <= 9999) {
                return (value / 1000).toFixed(2) + " L"
            } else if (value > 9999 && value <= 99999) {
                return (value / 1000).toFixed(2) + " L"
            } else if (value > 99999 && value <= 999999) {
                return (value / 1000).toFixed() + " L"
            } else {
                return (value / 1000000).toFixed(2) + " kL"
            }
        }
    },
    formatKG(value) {
        if (value != null || value != undefined) {
            value = Number(value)
            if (value <= 999) {
                return value + " gr"
            } else if (value > 999 && value <= 999999) {
                return (value / 1000).toFixed(1) + " KG"
            } else if (value > 999999) {
                return (value / 1000000).toFixed(2) + ` Ton`
            }
        }
    },
    sjonFormatter(value) {
        return JSON.stringify(JSON.parse(value), null, 2)
    },
    formatB(value) {
        if (value != null || value != undefined) {
            value = Number(value)
            if (value < 0) {
                return 0 + " mBar"
            } else if (value <= 999) {
                return value.toFixed() + " mBar"
            } else if (value > 999 && value <= 9999) {
                return (value / 1000).toFixed(2) + ` Bar`
            } else if (value > 9999 && value <= 99999) {
                return (value / 1000).toFixed(2) + ` Bar`
            } else {
                return (value / 1000).toFixed() + ` Bar`
            }
        }
    },
    formatT(value) {
        if (value != null && value != undefined) {
            value = Number(value)
            const min = value / 60
            const sec = value - Math.floor(min) * 60
            if (value < 60) {
                return `${sec.toString().padStart(2, "0")} sn`
            } else {
                return `${min.toFixed().toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")} dk`
            }
        } else return `0 sn`
    },
    formatW(value) {
        if (value != null && value != undefined) {
            value = Number(value.toFixed())
            if (value < -999) return `${(value / 1000).toFixed(2)} kW`
            else if (value < 1000) return `${value} W`
            else return `${(value / 1000).toFixed(2)} kW`
        } else return `--- W`
    },
}

app.config.globalProperties.$axios = {
    async get({ uri, orjUri, port, valueData, searchData }) {
        try {
            var req = await axios.get(axiosAddr + `${orjUri ? orjUri : ""}`, {
                params: {
                    token: localStorage.token,
                    selected_machine: localStorage.selected_machine,
                    value: { value: valueData, path: uri, port },
                    search: searchData,
                },
            })
            if (req.status == 200) return req.data
            else alertBox({ type: "success", msg: req.data?.message })
        } catch (error) {
            if (error.response) alertBox({ type: "warning", msg: error.response.data.message })
            else console.error(error.message)
            router.replace({ query: null })
            return []
        }
    },
    async delete({ uri, orjUri, port }) {
        try {
            var req = await axios.delete(axiosAddr + `${orjUri ? orjUri : ""}`, {
                params: {
                    token: localStorage.token,
                    selected_machine: localStorage.selected_machine,
                    value: { path: uri, port },
                },
            })
            alertBox({ type: "warning", msg: req.data?.message })
            if (req.status == 200) return true
        } catch (error) {
            if (error.response) alertBox({ type: "warning", msg: error.response.data.message })
            else console.error(error.message)
            return false
        }
    },
    async post({ uri, orjUri, port, valueData }) {
        return new Promise((resolve) => {
            axios
                .post(axiosAddr + `${orjUri ? orjUri : ""}`, {
                    token: localStorage.token,
                    selected_machine: localStorage.selected_machine,
                    value: { ...valueData, path: uri, port },
                })
                .then((response) => {
                    alertBox({ type: "success", msg: response.data?.message })
                    resolve(response.data)
                })
                .catch((error) => {
                    console.error(error)
                    if (error.response) alertBox({ type: "warning", msg: error.response.data.message })
                    else console.error(error.message)
                    resolve(undefined)
                })
        })
    },
}

app.config.globalProperties.$f = {
    // eslint-disable-next-line
    addrCheck({ port, orjUri, uri }) {
        return `http://${uri}:${port || 3010}${orjUri ? orjUri : ""}`
    },
    fileChech(folder, value) {
        try {
            if (value == null || value == undefined) return require(`@/assets/media/img/${"null.png"}`)
            else return require(`@/assets/media/img/${folder}/${value}`)
        } catch (error) {
            return require(`@/assets/media/img/${"delete.png"}`)
        }
    },
    async alerts_check(text) {
        return new Promise((resolve) => {
            app.config.globalProperties.$swal
                .fire({
                    title: text,
                    showCancelButton: false,
                    showDenyButton: true,
                    confirmButtonText: app.config.globalProperties.$t("op.success"),
                    denyButtonText: app.config.globalProperties.$t("op.cancel"),
                    timer: store.state.toastrAlert.alertduration,
                    timerProgressBar: true,
                })
                .then((result) => {
                    if (!result.isConfirmed) alertBox({ type: "warning", msg: app.config.globalProperties.$t("op.canceled") })
                    resolve(result.isConfirmed)
                })
        })
    },
}

/* ========================= ============================================================= ========================= */
app.use(store).use(router).mount("#app")
